const sl = {
  pleaseEnterUsername: "Prosimo, vnesite uporabniško ime",
  cannotFriendYourself: "Ne morete poslati prošnje za prijateljstvo sami sebi.",
  friendRequestSent: "Prošnja za prijateljstvo je bila poslana!",
  failedToSendRequest: "Pošiljanje prošnje ni uspelo",
  linkCopied: "Povezava je bila kopirana v odložišče!",
  backToInvites: "Nazaj na povabila",
  sendFriendRequestByUsername: "Pošlji prošnjo za prijateljstvo z uporabniškim imenom",
  enterUsername: "Vnesite uporabniško ime",
  send: "Pošlji",
  yourInviteQrCode: "Vaša QR koda za povabilo",
  inviteLink: "Povezava za povabilo",
  scanQrOrUseLink: "Skenirajte to QR kodo ali uporabite to povezavo za pošiljanje prošnje za prijateljstvo",
  copyInviteLink: "Kopiraj povezavo za povabilo",
  goToItem: "Pojdi na element",
  verificationEmailSent: "Potrditveno e-poštno sporočilo je bilo poslano! Preverite svoj nabiralnik.",
  verificationEmailFailed: "Pošiljanje potrditvenega e-poštnega sporočila ni uspelo. Poskusite znova.",
  verifyYourEmail: "Potrdite svoj e-poštni naslov",
  verifyEmailInstructions: "Prosimo, potrdite svoj e-poštni naslov za dostop do računa. V nabiralniku poiščite potrditveno povezavo.",
  sending: "Pošiljanje...",
  resendVerificationEmail: "Ponovno pošlji potrditveno e-pošto",
  login: "Prijava",
  register: "Registracija",
  home: "Domov",
  calendar: "Koledar",
  friends: "Prijatelji",
  profile: "Profil",
  logout: "Odjava",
  loading: "Nalaganje...",
  language: "Jezik",
  calendarSelectPlaceSuggestion: "Izberite lokacijo iz predlogov, da bodo dodane koordinate.",
  calendarSelectDateAndTime: "Izberite datum in čas.",
  calendarPositiveDuration: "Vnesite pozitivno trajanje.",
  calendarFutureDateRequired: "Datum in čas dogodka morata biti v prihodnosti.",
  calendarCreateEventFailed: "Dogodka ni bilo mogoče ustvariti. Poskusite znova.",
  cancel: "Prekliči",
  createNewEvent: "Ustvari nov dogodek",
  week: "Teden",
  month: "Mesec",
  eventTitle: "Naslov",
  date: "Datum",
  time: "Ura",
  duration: "Trajanje",
  endsAt: "Konča se ob",
  place: "Lokacija",
  searchForPlace: "Poišči lokacijo",
  placeSearchTip: "Namig: začnite tipkati in izberite rezultat za dodajanje koordinat.",
  description: "Opis",
  createEvent: "Ustvari dogodek",
  today: "Danes",
  previousMonth: "Prejšnji mesec",
  nextMonth: "Naslednji mesec",
  previous: "Prejšnji",
  next: "Naslednji",
  mondayShort: "Pon",
  tuesdayShort: "Tor",
  wednesdayShort: "Sre",
  thursdayShort: "Čet",
  fridayShort: "Pet",
  saturdayShort: "Sob",
  sundayShort: "Ned",
  more: "več",
  mustRespondWillBeforeReposting: "Pred ponovno objavo morate odgovoriti »Udeležil se bom«",
  event: "Dogodek",
  backToCalendar: "Nazaj na koledar",
  addToGoogleCalendar: "Dodaj v Google Koledar",
  when: "Kdaj",
  where: "Kje",
  openLocationInGoogleMaps: "Odpri lokacijo v Google Zemljevidih",
  hosts: "Gostitelji",
  yourResponse: "Vaš odgovor",
  currentResponse: "Trenutni odgovor",
  response_will: "Udeležil se bom",
  response_might: "Morda se bom udeležil",
  response_wont: "Ne bom se udeležil",
  willRunIntoYou: "Oglasil se bom",
  mightDropBy: "Morda se oglasim",
  wontCome: "Ne bom prišel",
  repostToMyFriends: "Ponovno deli s prijatelji",
  responses: "Odgovori",
  willAttend: "Se bo udeležil",
  reposted: "Ponovno deljeno",
  mightAttend: "Morda se bo udeležil",
  cancelEvent: "Prekliči dogodek",
  cancellationEmailNoticeBefore: "Udeleženci, ki so potrdili svojo udeležbo,",
  cancellationEmailNoticeAfter: "bodo po e-pošti obveščeni o preklicu.",
  optionalCancellationMessage: "Izbirno sporočilo za udeležence (največ 1000 znakov)",
  confirmCancelEvent: "Potrdi preklic dogodka",
  clear: "Počisti",
  confirmCancellation: "Potrdi preklic",
  confirmCancellationMessage: "Ali ste prepričani, da želite preklicati ta dogodek? Potrjeni udeleženci bodo obveščeni in dogodek bo odstranjen.",
  eventCancelledNotified: "Dogodek je preklican. Obveščeni:",
  attendees: "udeleženci",
  failedToCancelEvent: "Preklic dogodka ni uspel",
  back: "Nazaj",
  cancelled: "Preklicano",
  ok: "V redu",
  forgotPassword: "Pozabljeno geslo",
  email: "E-pošta",
  passwordResetLinkSent: "Če račun obstaja, je bila poslana povezava za ponastavitev gesla.",
  passwordResetRequestFailed: "Zahteva za ponastavitev gesla ni uspela.",
  sendResetLink: "Pošlji povezavo za ponastavitev",
  addFriend: "Dodaj prijatelja",
  incomingRequests: "Prejete prošnje",
  accept: "Sprejmi",
  deny: "Zavrni",
  myFriends: "Moji prijatelji",
  noFriendsYet: "Še nimate prijateljev. Začnite jih dodajati!",
  seeProfile: "Poglej profil",
  noEventsToRespondTo: "Ni dogodkov za odgovor",
  allCaughtUp: "Vse je pregledano. Kasneje preverite nove dogodke svojih prijateljev.",
  events: "Dogodki",
  unknown: "Neznano",
  noDescriptionProvided: "Opis ni bil podan.",
  will: "Da",
  maybe: "Morda",
  wont: "Ne",
  userNotFound: "Uporabnik ni bil najden",
  friendRequestSentSuccessfully: "Prošnja za prijateljstvo je bila uspešno poslana!",
  friendInvitation: "Povabilo k prijateljstvu",
  sendFriendRequest: "Pošlji prošnjo za prijateljstvo",
  loginToSendFriendRequest: "Za pošiljanje prošnje za prijateljstvo se prijavite",
  chooseLanguage: "Izberite jezik",
  invalidCredentials: "Neveljavni podatki za prijavo. Poskusite znova.",
  username: "Uporabniško ime",
  password: "Geslo",
  forgotPasswordQuestion: "Ste pozabili geslo?",
  dontHaveAccount: "Nimate računa?",
  registerHere: "Registrirajte se tukaj",
  invalidProfilePhotoType: "Neveljavna vrsta datoteke. Naložite sliko JPEG, PNG, GIF ali WebP.",
  invalidFileExtension: "Neveljavna pripona datoteke",
  allowedExtensions: "Dovoljeno",
  fileTooLarge: "Datoteka je prevelika",
  maximumFileSize: "Največ",
  profilePhotoRemoved: "Profilna fotografija je bila odstranjena.",
  failedToRemoveProfilePhoto: "Odstranjevanje profilne fotografije ni uspelo",
  profileUpdatedSuccessfully: "Profil je bil uspešno posodobljen!",
  failedToUpdateProfile: "Posodobitev profila ni uspela",
  privateEmailExplanation: "Samo vi lahko vidite svoj e-poštni naslov, da se izognete neželenim sporočilom zunaj platforme",
  yourEmailIsPrivate: "Vaš e-poštni naslov je zaseben.",
  profilePhoto: "Profilna fotografija",
  removePhoto: "Odstrani fotografijo",
  firstName: "Ime",
  lastName: "Priimek",
  tellPeopleAboutYourself: "Povejte nekaj o sebi",
  whereToContactMe: "Kako stopiti v stik z menoj",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Shrani",
  notSet: "Ni nastavljeno",
  editProfile: "Uredi profil",
  imageToCrop: "Slika za obrezovanje",
  zoom: "Povečava",
  usePhoto: "Uporabi fotografijo",
  name: "Ime",
  whereToContact: "Kontakt",
  removeFriendship: "Odstrani prijateljstvo",
  confirmRemoveFriend: "Potrdi odstranitev prijatelja",
  confirmRemoveFriendBefore: "Ali ste prepričani, da želite odstraniti",
  confirmRemoveFriendAfter: "s seznama prijateljev?",
  friendRemoved: "Prijatelj je bil odstranjen.",
  failedToRemoveFriend: "Odstranjevanje prijatelja ni uspelo.",
  confirmRemove: "Potrdi odstranitev",
  error: "Napaka",
  removed: "Odstranjeno",
  passwordsDoNotMatch: "Gesli se ne ujemata",
  registrationFailed: "Registracija ni uspela. Poskusite znova.",
  confirmPassword: "Potrdi geslo",
  alreadyHaveAccount: "Že imate račun?",
  loginHere: "Prijavite se tukaj",
  passwordResetSuccessfully: "Geslo je bilo uspešno ponastavljeno.",
  failedToResetPassword: "Ponastavitev gesla ni uspela.",
  resetPassword: "Ponastavi geslo",
  newPassword: "Novo geslo",
  confirmNewPassword: "Potrdi novo geslo",
  setNewPassword: "Nastavi novo geslo",
  emailVerifiedSuccessfully: "E-poštni naslov je bil uspešno potrjen!",
  emailVerificationFailed: "Potrditev ni uspela. Povezava je morda neveljavna ali potekla.",
  verifying: "Preverjanje...",
  verified: "Potrjeno!",
  redirectingToHome: "Preusmerjanje na domačo stran...",
  verificationFailed: "Potrditev ni uspela",
  goToHome: "Pojdi na domačo stran",
  about: "O aplikaciji",
  aboutConceptTitle: "Koncept",
  aboutCreatorIntroduction: "Živjo, sem Crypt0, plezalec in ustvarjalec Run Into Me.",
  aboutCreatorStory: "Spletno mesto sem ustvaril, ker sem družaben in sem porabil preveč časa za organizacijo plezanja z drugimi.",
  aboutPlanningProblem: "Vsem sem želel hkrati sporočiti, kdaj in kje bom plezal, brez uradnega vabila.",
  aboutDeveloperSolution: "Nato sem se spomnil, da sem razvijalec in lahko rešitev ustvarim sam.",
  aboutWelcome: "Dobrodošli v Run Into Me, kjer prijateljem sporočite dejavnosti, ki se jim lahko pridružijo brez pritiska.",
  aboutCallToAction: "Tukaj objavite naslednjo dejavnost, ki je zabavnejša skupaj!",
  aboutTutorialTitle: "Navodila",
  aboutCalendarCreateEvent: "Na zaslonu Koledar lahko ustvarite tudi nov dogodek.",
  aboutEventColorsIntroduction: "Barve prikazujejo stanje udeležbe:",
  aboutColorGold: "Zlata",
  aboutColorGoldDescription: "Dogodek gostite.",
  aboutColorGreen: "Zelena",
  aboutColorGreenDescription: "Dogodka se boste udeležili.",
  aboutColorOrange: "Oranžna",
  aboutColorOrangeDescription: "Odgovorili ste »morda«.",
  aboutColorBlue: "Modra",
  aboutColorBlueDescription: "Niste še odgovorili.",
  aboutColorGray: "Siva",
  aboutColorGrayDescription: "Vabilo ste zavrnili.",
  aboutCalendarEventDetails: "Kliknite dogodek za podrobnosti in odgovor.",
  aboutFriendPageTitle: "Stran prijateljev",
  aboutFriendPageDescription: "Vnesite uporabniško ime ali pošljite povezavo / kodo QR.",
  aboutHomePageTitle: "Domača stran",
  aboutHomePageDescription: "Oglejte si dogodke in sporočite, ali pridete.",
  aboutRepostScreenTitle: "Zaslon za ponovno objavo",
  aboutGoogleCalendarDescription: "S tem gumbom dodajte dogodek v Google Koledar.",
  aboutRepostDescription: "Po potrditvi lahko dogodek ponovno objavite prijateljem.",
};

export default sl;